__turbopack_context__.v({
  "action-container": "tl3KlW_action-container",
  "action-description": "tl3KlW_action-description",
  "action-media": "tl3KlW_action-media",
  "merch-card": "tl3KlW_merch-card",
  "tag-link": "tl3KlW_tag-link",
});
